import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    actionsContainer: { display: 'flex', alignItems: 'center', gap: '8px' },
    addButtonYellow: {
      marginLeft: 5,
      fontSize: 12,
      padding: '5px 10px',
      backgroundColor: palette.navCompanyContextActions,
      color: palette.white,
      '&:hover': {
        backgroundColor: palette.navCompanyContextActions,
        color: palette.white,
      },
    },
    addButtonGreen: {
      marginLeft: 5,
      fontSize: 12,
      padding: '5px 10px',
      backgroundColor: palette.navAdminActions,
      color: palette.white,
      '&:hover': {
        backgroundColor: palette.navAdminActions,
        color: palette.white,
      },
    },
    addButtonBlue: {
      marginLeft: 5,
      fontSize: 12,
      padding: '5px 10px',
      backgroundColor: palette.navOperatorActions,
      color: palette.white,
      '&:hover': {
        backgroundColor: palette.navOperatorActions,
        color: palette.white,
      },
    },
    addButtonGray: {
      marginLeft: 5,
      fontSize: 12,
      padding: '5px 10px',
      backgroundColor: palette.navSuperAdminActions,
      color: palette.white,
      '&:hover': {
        backgroundColor: palette.navSuperAdminActions,
        color: palette.white,
      },
    },
    addButtonIcon: {
      fontSize: '20px !important',
      '& .MuiButton-startIcon': {
        marginRight: 2,
      },
    },
    divider: { width: '100%', marginTop: '16px' },
    searchContainer: { alignItems: 'center', justifyContent: 'space-between' },
    tableRow: {
      height: 20,
      cursor: 'pointer',
      whiteSpace: 'nowrap',
      '& .MuiTableCell-root': {
        padding: '0 0 0 16px',
        color: palette.gray,
      },
      '&:hover': {
        background: `${palette.superLightDeepBlue} !important`,
        cursor: 'pointer',
      },
    },
    centerFields: {
      textAlign: 'center',
      fontSize: 12,
      '& .MuiIconButton-root': {
        padding: 0,
      },
    },
    accessButton: {
      fontSize: 15,
      color: palette.blue,
    },
    textLong: {
      whiteSpace: 'nowrap',
      fontSize: 12,
    },
    dateField: {
      fontSize: 12,
      whiteSpace: 'nowrap',
    },
    menuOptions: {
      fontSize: 12,
      fontWeight: 500,
    },
  });
